// /src/App.tsx
import React from 'react';
import Routes from './routes';
import './assets/styles.css';

const App: React.FC = () => {
  return <Routes />;
};

export default App;